<template>
    <div class="box">
        <router-view v-if="show" />
    </div>
</template>
<script>

export default {
    name: 'App',
    data() {
        return {
            show: false
        };
    },
    watch: {
        $route: function(val) {
            if (this.isMobile()) {
                if (val.path.indexOf('/m/') === -1 && val.path !== '/index') {
                    this.$router.push('/m' + val.fullPath);
                    return;
                }
                this.show = true;
            } else {
                if (val.path.indexOf('/m/') !== -1) {
                    this.$router.push('/' + val.fullPath.split('/m/')[1]);
                    return;
                }
                this.show = true;
            }
        }
    },
    created() {
        this.$store.commit('getPageType');
        this.$store.commit('getPromoterId');
        this.show = this.$route.path !== '/';
        window.onbeforeunload = function(e) {
            window.sessionStorage.clear();
        };
    },
    methods: {
        isMobile() {
            return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        }
    }
};
</script>
<style lang="scss">
html, body, .box {
    padding: 0;
    margin: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    background: #f4f4f6;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Lantinghei SC", "Helvetica Neue", Arial, "Open Sans", "Hiragino Sans GB", sans-serif;
    line-height: 1.5;
    font-size: 14px;
    color: #292c32;
    font-weight: 400;
}
</style>
